// extracted by mini-css-extract-plugin
module.exports = {"PrintId":"PrintId_PrintId__2XApR"};